import { useCallback } from "react";
import useFetchAsync from "src/hooks/useFetchAsync";
import { post, useGet } from "src/http-clients/clients";

export const useGetUserPlans = () => {
  return useGet("/users/plans/plans-list");
};

export const useAssignPlanToUser = () => {
  const assignPlan = useCallback(
    ({
      planId,
      planName,
      price,
    }: {
      planId: number;
      planName: string;
      price: number;
    }) => {
      return post("/users/plans/assign-plan", { planId, planName, price });
    },
    []
  );

  return useFetchAsync(assignPlan);
};
